import { documentHasElements } from "modules/dom";

documentHasElements(".subcategory-download-block", (subcategoryDownloadBlocks) => {
    subcategoryDownloadBlocks.forEach((subcategoryDownloadBlock) => {
        const downloadButtons = subcategoryDownloadBlock.querySelectorAll(".download > p");

        downloadButtons.forEach((button) => {
            button.addEventListener("click", () => {
                button.closest("div")?.querySelector("ul")?.classList.toggle("active");
            });
        });
    });
});